import type { PiletApi } from '@chess/platform-web';
import { LOG_API } from '@chess/api-log';
import { configureLogging, defaultLevel } from './setup.ts';

// Provides `log` over LogTape. Every plugin writes through the `log` API and
// never to the console; this plugin decides where records go. It also
// catches what nobody else does: uncaught errors and unhandled rejections,
// logged under `chess.app` so a future backend sink sees crashes first.
export function setup(app: PiletApi) {
  const log = configureLogging({ lowest: defaultLevel() });
  app.registerApi(LOG_API, log);

  const appLog = log.child('app');
  window.addEventListener('error', (event) => {
    appLog.error('uncaught error', event.error instanceof Error ? event.error : { message: event.message });
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    appLog.error('unhandled rejection', reason instanceof Error ? reason : { reason: String(reason) });
  });

  log.child(app.meta.name).debug('logging ready', { lowest: defaultLevel() });
}
